import { useState } from "react";
import { GetOrganizationLogoApiRequest } from "api/SubUsersController";
import {
  IS_LOCALHOST_TREATED_AS_CUSTOM_DOMAIN,
  TEST_LOCALHOST_CUSTOM_DOMAIN,
} from "utils/globalConsts";
import checkCurrDomainIsOrgDomain from "helpers/checkCurrDomainIsOrgDomain";

const useOrganizationLogo = () => {
  const [logo, setLogo] = useState("");

  const isCustomDomain = checkCurrDomainIsOrgDomain();

  const fetchLogo = isCustomDomain
    ? async () => {
        const response = await GetOrganizationLogoApiRequest(
          IS_LOCALHOST_TREATED_AS_CUSTOM_DOMAIN
            ? TEST_LOCALHOST_CUSTOM_DOMAIN
            : window.location.hostname
        );

        if (response.status === "success" && response.data) {
          setLogo(response.data);
        }
      }
    : () => {};

  return { logo, fetchLogo };
};

export default useOrganizationLogo;
